'use strict';

import ready from './ready';
import {mutate} from './promise-fastdom';
// import promiseRAF from './promise-raf';
import promiseIdle from './promise-idle';
import promiseImage from './promise-image';
import {trigger} from './events';
import promiseRAF from './promise-raf';
import SelectorObserver from './SelectorObserver';

let intersectionObserver;

ready().then(promiseIdle()).then(function () {

    // disable in prefers-reduced-motion
    if (typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    intersectionObserver = new IntersectionObserver(intersect, {
        rootMargin: '200% 0px -40% 0px',
        threshold: 0,
    });
    
    const selector = '.reveal__anchor';
    document.querySelectorAll(selector).forEach(handleAnchor);

    // listen for future tree modifications
    const so = new SelectorObserver(selector);
    so.listen('added', handleAnchor);
    so.listen('removed', forgetAnchor);
});

function handleAnchor(anchor) {
    const node = anchor.closest('.reveal');
    if (!node) {
        return;
    }
    return Promise.resolve()
        .then(mutate(function () {
            node.classList.add('reveal--hidden');
        }))
        .then(promiseIdle())
        .then(function () {
            intersectionObserver.observe(anchor);
        });
}

function forgetAnchor(anchor) {
    intersectionObserver.unobserve(anchor);
}

function intersect(intersections) {
    intersections.forEach(function (intersection) {
        const node = intersection.target.closest('.reveal');
        if (!node) {
            return;
        }
        if (intersection.isIntersecting) {
            if (!node.classList.contains('reveal--wait-image')) {
                return reveal(node);
            }
            return promiseImage(node.querySelector('img')).then(function () {
                return reveal(node);
            });
        }
        if (node.classList.contains('reveal--reverse')) {
            return hide(node);
        }
    });
}

function reveal(node) {
    node.reveal = (node.reveal ? node.reveal : Promise.resolve())
        .then(promiseRAF)
        .then(function () {
            trigger.call(node, 'reveal/on');
            node.classList.add('reveal--run');
        })
        .then(promiseRAF)
        .then(function () {
            node.classList.remove('reveal--hidden');
        });
    return node.reveal;
}

function hide(node) {
    node.reveal = (node.reveal ? node.reveal : Promise.resolve())
        .then(promiseRAF)
        .then(function () {
            trigger.call(node, 'reveal/off');
            node.classList.add('reveal--hidden');
        });
    return node.reveal;
}
